import axios from 'axios';
// ##### 25-01-14 Komarov
import { decrypt } from '../../helpers/crypto';
// ##### 25-01-01 Komarov
import { isBrowser } from '../../../server/helpers/browserDetector';

export default class PaymentService {
  data = [];

  // ##### 23-12-22 Komarov
  bookingFromCart = () => {
    const orderDataEncrypted = localStorage.getItem('orderData');
    // ##### 23-12-22 Komarov
    const ActionRQ = decrypt(orderDataEncrypted);
    return axios
      .post(
        `${process.env.REACT_APP_SMART_URL}interface/xmlsubj/`,
        // ##### 25-01-11 Komarov
        JSON.stringify({ ActionRQ, arkturSiteB: isBrowser ? 1 : 0 })
        // postData
      )
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // ##### 25-04-30 Komarov
        console.error('[axios error]: ', error);
      });
  };

  getPaymentInfo = () => {
    const orderDataEncrypted = localStorage.getItem('orderData');
    const orderData = decrypt(orderDataEncrypted);
    // ##### 23-12-22 Komarov
    const ActionRQ = {
      ...orderData,
      action: 'GetPaymentInfoRQ',
    };
    return axios
      .post(
        `${process.env.REACT_APP_SMART_URL}interface/xmlsubj/`,
        // ##### 25-01-11 Komarov
        JSON.stringify({ ActionRQ, arkturSiteB: isBrowser ? 1 : 0 })
      )
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // ##### 25-04-30 Komarov
        console.error('[axios error]: ', error);
      });
  };

  // ##### 25-05-20 Komarov
  getPaymentVoucher = (service_id, smart_reference) => {
    const ActionRQ = {
      username: process.env.REACT_APP_SMART_USERNAME,
      password: process.env.REACT_APP_SMART_PASSWORD,
      user_id: 1426,
      action: 'GetPaymentVoucherRQ',
      data: {
        site_service_id: 1, // index of the service in the site
        smart_service_id: service_id, // booking_entity.id in Smart
        smart_reference: smart_reference, // booking_entity.id in Smart
        site_client_id: 3, // it must be BUYER only
        smart_client_id: 1426, // it must be BUYER only
      },
    };
    // return axios.post('http://smartbooker.biz/interface/xmlsubj/', JSON.stringify({ActionRQ}))
    return axios
      .post(
        `${process.env.REACT_APP_SMART_URL}interface/xmlsubj/`,
        // ##### Komarov 2025-09-23
        JSON.stringify({ ActionRQ, arkturSiteB: isBrowser ? 1 : 0 })
      )
      .then(response => {
        const responseData = response.data;
        // console.log("work_with_payment: responseData: getPaymentVoucher ", responseData);
        // console.log("work_with_payment: response ", response);
        return responseData;
        // return response;
      })
      .catch(error => {
        console.error('[axios error]: ', error);
      });
  };
}
